module.exports = __webpack_public_path__ + "img/drainage.d890f884.svg";